import React from 'react';
import { CourseModule } from '../../api/studentCoursesApi';
import { PageModuleContent } from './page';
import { QuizModuleContent } from './quiz';

interface ModuleContentRendererProps {
  contextId: string;
  moduleId: string;
  modname: string;
  module: CourseModule | null;
}

/**
 * ModuleContentRenderer - Dispatcher component that routes to the appropriate
 * module-specific component based on the module type (modname)
 * 
 * This allows easy extension for different module types:
 * - page: PageModuleContent
 * - quiz: QuizModuleContent (to be implemented)
 * - assignment: AssignmentModuleContent (to be implemented)
 * - resource: ResourceModuleContent (to be implemented)
 * - url: URLModuleContent (to be implemented)
 */
const ModuleContentRenderer: React.FC<ModuleContentRendererProps> = ({
  contextId,
  moduleId,
  modname,
  module,
}) => {
  // Route to appropriate component based on module type
  switch (modname) {
    case 'page':
      return (
        <PageModuleContent
          contextId={contextId}
          moduleId={moduleId}
          module={module}
        />
      );
    
    case 'quiz':
      return (
        <QuizModuleContent
          contextId={contextId}
          moduleId={moduleId}
          module={module}
        />
      );
    
    case 'assignment':
      // TODO: Implement AssignmentModuleContent component
      return (
        <div className="bg-white rounded-lg border border-gray-200 p-8">
          <div className="text-center text-gray-600">
            <p className="font-medium">Assignment Module</p>
            <p className="text-sm mt-2">Assignment rendering will be implemented here</p>
          </div>
        </div>
      );
    
    default:
      return (
        <div className="bg-white rounded-lg border border-gray-200 p-8">
          <div className="text-center text-gray-600">
            <p className="font-medium">Module Type: {modname}</p>
            <p className="text-sm mt-2">Rendering for this module type is not yet implemented</p>
          </div>
        </div>
      );
  }
};

export default ModuleContentRenderer;
